const BADGES = [
  {
    name: "Level 1",
    filename: "turtle.svg",
    caption: "Your first badge!",
  },
  {
    name: "Level 2",
    filename: "battery.svg",
    caption: "Supercharged! You have invented the battery!",
  },
  {
    name: "Level 3",
    filename: "nucleus_purple.svg",
    caption: "You have discovered the atom!",
  },
  {
    name: "Level 4",
    filename: "beanpod.svg",
    caption: "You have discovered photosynthesis!",
  },
  {
    name: "Level 5",
    filename: "stars.svg",
    caption: "You have propelled a spacecraft to Mars!",
  },
  {
    name: "Level 6",
    filename: "sun.svg",
    caption: "You have discovered thermal radiation",
  },
  {
    name: "Level 7",
    filename: "dna.svg",
    caption: "You have discovered the structure of DNA",
  },
  {
    name: "Level 8",
    filename: "map.svg",
    caption: "You have discovered the structure of DNA",
  },
  {
    name: "Level 9",
    filename: "nucleus_blue.svg",
    caption: "You have discovered nuclear fission!",
  },
];

export default BADGES;
